const materials = [
    {
        name: 'Forex',
        material: 'forex-circle',
    },
    {
        name: 'Dibond',
        material: 'dibond-circle',
    }
];

export default materials;